import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './TimetableGrid.css';
import LectureTimeRow from '../lectureTimeRow/LectureTimeRow';
import BreakCardRow from '../breakCardRow/BreakCardRow';
import ActionsBar from './actionsBar/ActionsBar';
import {TTimetableItem, TLectureTimeGroup, TTimeGroup} from '../../../../redux/timetable/timetable.type';

interface TimetableGridHandlers {
    onAddLecture?: (tsid: number | null) => void;
    onAddBreak?: () => void;
    onAddItem?: () => void;
    onMenuClick?: (item: TTimetableItem) => void;
    onTicketsClick?: (item: TTimetableItem) => void;
    onEditLecture?: (item: TTimetableItem) => void;
}

interface TimetableGridProps {
    timeGroups: TTimeGroup[];
    expanded?: boolean;
    handlers?: TimetableGridHandlers;
}

function TimetableGrid({
    timeGroups = [] as TTimeGroup[],
    expanded = true,
    handlers = {},
}: TimetableGridProps) {
    const {
        onAddLecture = () => {},
        onAddBreak = () => {},
        onAddItem = () => {},
        onMenuClick = () => {},
        onTicketsClick = () => {},
        onEditLecture = () => {},
    } = handlers;
    const {t} = useTranslation('timetable');
    let runningIndex = 0;
    const groups = timeGroups.map(group => {
        if('isBreak' in group) return group;
        const result: TLectureTimeGroup = {...group, startIndex: runningIndex};
        runningIndex += group.lectures?.length || 0;
        return result;
    });

    if(groups.length === 0) {
        return (
            <css.container>
                <css.emptyState>{t('noLectures')}</css.emptyState>
                <ActionsBar onAddItem={onAddItem} onAddBreak={onAddBreak} />
            </css.container>
        );
    }

    const firstLectureIdx = groups.findIndex(g => !('isBreak' in g));

    return (
        <css.container>
            {groups.map((group, i) => (
                <React.Fragment key={'isBreak' in group ? `break-${group.breakItem.ttid}` : `row-${group.time}`}>
                    {'isBreak' in group ? (
                        <BreakCardRow
                            time={group.time}
                            breakItem={group.breakItem}
                            onMenuClick={() => onMenuClick(group.breakItem)}
                        />
                    ) : (
                        <LectureTimeRow
                            timeGroup={group as TLectureTimeGroup}
                            expanded={expanded}
                            isFirst={i === firstLectureIdx}
                            onAddLecture={(tsid) => onAddLecture(tsid)}
                            onTicketsClick={onTicketsClick as () => void}
                            onEditLecture={onEditLecture}
                        />
                    )}
                    {i < groups.length - 1 && <css.separator />}
                </React.Fragment>
            ))}
            <css.separator />
            <ActionsBar onAddItem={onAddItem} onAddBreak={onAddBreak} />
        </css.container>
    );
}

export default TimetableGrid;
